import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'

export const Popover = PopoverPrimitive.Root
export const PopoverTrigger = PopoverPrimitive.Trigger

export function PopoverContent({
  children,
  align = 'end',
  sideOffset = 6,
  className = '',
}: {
  children: React.ReactNode
  align?: 'start' | 'center' | 'end'
  sideOffset?: number
  className?: string
}) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        align={align}
        sideOffset={sideOffset}
        className={`z-[99999] flex flex-col min-w-[150px] rounded-2xl border border-border-color bg-white shadow-xl py-2 outline-none
          data-[state=open]:animate-in data-[state=closed]:animate-out
          data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0
          data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95
          data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2
          ${className}`}
      >
        {children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  )
}

export function PopoverItem({
  onClick,
  children,
  icon,
  variant = 'default',
  disabled = false,
}: {
  onClick?: () => void
  children: React.ReactNode
  icon?: React.ReactNode
  variant?: 'default' | 'danger'
  disabled?: boolean
}) {
  const color = variant === 'danger' ? 'text-red-600 hover:bg-red-50' : 'text-slate-800 hover:bg-slate-50'
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${color}`}
    >
      {icon && <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">{icon}</span>}
      <span className="truncate">{children}</span>
    </button>
  )
}
